import {groq} from 'next-sanity';

import {PORTABLE_TEXT_FRAGMENT} from '@/modules/foundation/sanity/portable-text/query';

import type {TextSchema} from './schema';

export const TEXT_SECTION_FRAGMENT = groq`
	...,
	content[] {
		${PORTABLE_TEXT_FRAGMENT}
	}
`;

// TODO: This should have the resolved portable text field type:
export type TextSectionFragmentType = TextSchema;
